import * as React from 'react'
// components
import { HoverablePopover } from 'components/UI'
import { TableRow } from '@mui/material'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// types
import { Modals } from 'constants/modals'
import { IObjectSecurity } from 'types/graphql'
// themes
import { EllipsizedText } from 'themes/views/generic'
// views
import { CheckedIcon, TableCell, TEXT_STYLE } from 'themes/views/tables'

interface Props {
  data: IObjectSecurity
}

const Row: React.FC<Props> = ({ data }) => {
  const { showModal } = useShowModal({ modalType: Modals.OBJECT_SECURITY_MODAL })

  const { id, name, active, description, securityProfiles, objectEntity } = data

  const profiles = securityProfiles.map(({ name }) => name).join(', ')

  const showObjectSecurityModal = () => showModal({ objectSecurity: data, isEdit: true })

  return (
    <TableRow hover>
      <TableCell size={20}>
        <HoverablePopover
          trigger={
            <EllipsizedText
              data-testid='object-security'
              data-entity-id={id}
              onClick={showObjectSecurityModal}
              style={TEXT_STYLE}>
              {name}
            </EllipsizedText>
          }>
          {name}
        </HoverablePopover>
      </TableCell>
      <TableCell size={10}>{objectEntity.name}</TableCell>
      <TableCell size={5}>{active && <CheckedIcon />}</TableCell>
      <TableCell size={25}>{profiles}</TableCell>
      <TableCell size={40}>{description}</TableCell>
    </TableRow>
  )
}

export default Row
